import axios from './HTTP'

export default {
  create (params, callback) {
    axios
      .post('/api/promotions.json', {
        user_id: params.employee_id,
        notes: params.notes,
        date: params.date,
      })
      .then(response => ( callback(response.data) ))
  },
}
